import {
  includeRule,
  excludeRule,
  hideOptionSet
}
from './rules_functions.js';

  
  
export function rules_bsetc(newState, state) {
  //rules with 4 conditions:
  var newrule = includeRule(newState, state, 'bsetc')
  var show = hideOptionSet(newState, state, [ ['band', ['0']]])
  if (show == true)   show  = hideOptionSet(newState, state, [ ['bset', ['0']]])
    newrule = excludeRule(newState, state, [
      ['ce', ['LD']],
      ['bsetc', ['BDI','BDID']]], newrule)

  newrule['show']  = show
    return newrule
}


